module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteURL":"https://www.kineticplans.com"},
    },{
      plugin: require('../../../node_modules/@leshen/gatsby-theme-leshen/gatsby-browser.js'),
      options: {"plugins":[],"analyticsId":"GTM-5B2T8S46","brandTokens":["WDS","WDSB","TND","WDSS"],"mapiBrandToken":"WDS","siteName":"kineticplans","siteURL":"https://www.kineticplans.com","defaultTitleTemplate":"","defaultPhone":"8338151183","phoneSymbol":"-","defaultPromoCode":"45807","smartyStreetsWebsiteKey":"17515620243222457","addressQualificationCode":"windstream","convertProjectID":"10046062","vwoProjectID":"894940","datasetKeys":["kinetic-aoa"]},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"kineticplans","short_name":"kineticplans","start_url":"/","background_color":"#22a881","theme_color":"#22a881","icon":"src/images/favicon.svg","display":"browser","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"83aaacc8a1a949a286d4d5a89981e0dc"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"typekit":{"id":"rmk3sth"}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
